import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import noPicture from 'images/nopic.jpg'
import { apiImageUrl, urlName } from 'lib/utils'
import './style.scss'

import ProductCardShortInfo from './ProductCardShortInfo'
import ProductCardTallInfo from './ProductCardTallInfo'
import AutoSize from 'components/common/AutoSize'

export class ProductCard extends PureComponent {
  static propTypes = {
    article: PropTypes.object.isRequired,
    addToCart: PropTypes.func.isRequired,
    lng: PropTypes.object.isRequired,
    showTall: PropTypes.bool.isRequired,
    news: PropTypes.bool,
    seasonNews: PropTypes.bool,
    orderMonths: PropTypes.string,
    orderMonthsSeason: PropTypes.string,
    currentLanguage: PropTypes.string.isRequired,
    newsText: PropTypes.string,
    seasonNewsText: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.state = {
      quantity: null,
      addQuantities: [],
      addedToCart: false,
      isHovered: false,
    }
  }

  onChange = (e) => {
    const {
      name,
      value
    } = e.target

    this.setState({
      [name]: Number(value),
      addedToCart: false
    })
  }

  addToCart = () => {
    this.props.addToCart(this.props.article.Id, this.state.quantity)
    this.setState({
      addedToCart: true
    })
  }

  onMouseEnter = () => {
    this.setState({ isHovered: true })
  }

  onMouseLeave = () => {
    this.setState({ isHovered: false })
  }

  //Do not remove!
  //Workaround for iOS that require onClick event on hover elements
  // onClick = () => { }
  onClick = () => {
    const articleRoute = `/article/${this.props.article.Id}/` + urlName(this.props.article.ArticleText)
    this.props.history.push(articleRoute)
  }

  componentWillMount() {
    const {
      QuantityPerPackage,
      ImageIds
    } = this.props.article

    const options = []
    for (let i = 1; i <= 10; i++) {
      options.push(i * QuantityPerPackage)
    }

    this.setState({
      addQuantities: options,
      quantity: options[0]
    })

    // Preload second image to avoid flicker on hover
    if (ImageIds && ImageIds.length > 1) {
      const img = new Image()
      img.src = apiImageUrl('ArticleThumbnail', ImageIds[1])
    }
  }

  render() {
    const {
      ArticleText,
      ImageId,
      Id,
      RegularPrice,
      Discount,
      News,
      SeasonNews,
      ImageIds
    } = this.props.article

    const imageUrl = ImageId ? apiImageUrl('ArticleThumbnail', ImageId) : noPicture
    const secondImageId = ImageIds && ImageIds.length > 1 ? ImageIds[1] : null
    const secondImageUrl = secondImageId
      ? apiImageUrl('ArticleThumbnail', secondImageId)
      : null
    const hasSecondImage = !!secondImageUrl
    const displayImageUrl = this.state.isHovered && hasSecondImage ? secondImageUrl : imageUrl
    const articleRoute = `/article/${Id}/` + urlName(ArticleText)

    const imageStyle = {
      backgroundImage: `url(${displayImageUrl})`
    }

    let cardNewsText = null
    if (SeasonNews)
      cardNewsText = this.props.seasonNewsText
    else if (News)
      cardNewsText = this.props.newsText

    return (
      <div className={classNames('productCard', { tall: this.props.showTall })} >
        {cardNewsText ? <div className="new"><AutoSize maxWidth={70} maxFontSize={14}>{cardNewsText}</AutoSize></div> : null}
        {RegularPrice ? <div className="sale">{Math.floor(Discount)} %</div> : null}
        {this.state.addedToCart ? <div className="kopInfo">{this.state.quantity}st har lagts i varukorgen.</div> : null}
        <div
          onClick={this.onClick}
          onMouseEnter={hasSecondImage ? this.onMouseEnter : undefined}
          onMouseLeave={hasSecondImage ? this.onMouseLeave : undefined}
          className="imageContainer"
          style={imageStyle}
        ></div>
        {
          this.props.showTall ?
            <ProductCardTallInfo
              article={this.props.article}
              lng={this.props.lng}
              addToCart={this.addToCart}
              onChange={this.onChange}
              addQuantities={this.state.addQuantities}
              quantity={this.state.quantity}
              orderMonths={this.props.orderMonths}
              orderMonthsSeason={this.props.orderMonthsSeason}
              currentLanguage={this.props.currentLanguage} />
            :
            <ProductCardShortInfo
              article={this.props.article}
              lng={this.props.lng}
              route={articleRoute} />
        }
        <div className="whiteOverlay"></div>
      </div>
    )
  }
}

export default withRouter(ProductCard)